import React from 'react';

import { connect } from 'react-redux';
import { Modal } from 'antd';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Box, ShowIf, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import PELFiltrarPage from '../../../pel/pages/PELFiltrarPage';
import PELSeleccionarPage from '../../../pel/pages/PELSeleccionarPage';
import {
  obtenerFiltrosFromDB,
  seleccionarCaracteristicaFiltrado,
  setModo,
  setVieneDe,
} from '../../../../state/actions/creators/pel.actioncreator';
import { permisosType } from '../../../auth/types/permisos.types';
import { promocionType } from '../../types/promociones.types';
import {
  formateaDatosMontura,
  formatearDatosGraduacion,
} from '../../../../helpers/modules/pel.helper';
import ResumenEncargo from '../../containers/creador/ResumenEncargo.datadisplay';
import {
  setGafaGraduada,
} from '../../../../state/actions/creators/encargos.creador.actioncreator';
import VentanaTrazadora from '../../../biselado/VentanaTrazadora';
import { iniciarVentanaTrazadora } from '../../../../state/actions/creators/trazadora.actioncreator';
import { formatearDatosDeTrazadora } from '../../../../helpers/modules/trazadora.helper';
import Page from '../../../shared/components/layout/Page.layout';

const FILTRAR_PAGE = 'FILTRAR_PAGE';
const SELECCIONAR_PAGE = 'SELECCIONAR_PAGE';

class EncargosCrearPELPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: FILTRAR_PAGE, seleccionModalTitle: 'Selección de lentes' };
  }

  componentDidMount() {
    const { page } = this.state;
    const {
      setModo, setVieneDe, seleccionarCaracteristicaFiltrado, obtenerFiltrosFromDB,
      permisos, encargos, promocion, match,
    } = this.props;
    if (!match) return;
    const { params: { encargoUUID, linea } } = match;
    const encargo = encargos.find(e => e.uuid === encargoUUID);
    if (!encargo) {
      this.goBack();
      return;
    }
    if (page !== FILTRAR_PAGE) return;
    const tienePromocion = promocion !== null;
    const graduacion = encargo.cabecera.cliente && encargo.cabecera.cliente.graduaciones && encargo.cabecera.cliente.graduaciones.optometricas ? encargo.cabecera.cliente.graduaciones.optometricas.seleccion : null;
    const usaMiCatalogo = permisos.configuracion.pel === 'S';
    const puedeElegirCatalogo = (usaMiCatalogo && !tienePromocion)
      || (usaMiCatalogo && tienePromocion && !promocion.paraLentesGenericas);
    setModo({
      modo: 'seleccion',
      aplication: 'gw2',
      tienePromocion,
      usaMiCatalogo,
      numPack: tienePromocion && encargo.pack ? encargo.pack.id : -1,
      puedeElegirCatalogo,
      paraLentesGenericas: tienePromocion ? promocion.paraLentesGenericas : false,
    });
    setVieneDe('encargo');
    if (graduacion && graduacion.id) {
      seleccionarCaracteristicaFiltrado({
        nombre: 'graduacion',
        id: 'graduacion',
      }, {
        valor: graduacion.id,
        derecho: formatearDatosGraduacion(graduacion, permisos.configuracion.trabajar_cilindro_positivo).graduacionOjoDerecho,
        izquierdo: formatearDatosGraduacion(graduacion, permisos.configuracion.trabajar_cilindro_positivo).graduacionOjoIzquierdo,
      },
      permisos);
    }
    if (encargo.detallesTemporales.length > 0) {
      const tipoArticuloMonturas = parseInt(permisos.configuracion.articulo_monturas, 10);
      const tipoArticuloSol = parseInt(permisos.configuracion.articulo_sol, 10);
      const montura = encargo.detallesTemporales.find(e => (e.cdgtipo === tipoArticuloMonturas || e.cdgtipo === tipoArticuloSol) && e.linea === linea - 1);
      if (graduacion && graduacion.id && montura && montura.articulo) {
        const datosForma = formateaDatosMontura(montura.articulo, graduacion);
        if (datosForma) {
          seleccionarCaracteristicaFiltrado(
            {
              nombre: 'montura',
              id: 'montura',
            },
            {
              id: montura.articulo.codigo ? montura.articulo.codigo : montura.articulo.id,
              descripcion: montura.articulo.descripcion,
              valor: montura.linea,
              tipoMontura: montura.articulo.codigoTipo,
              puente: datosForma.puente,
              calibre: datosForma.calibre,
              tieneFormaOma: datosForma.tieneFormaOma,
              diametroMinimo: datosForma.diametroMinimo,
              datosOma: { oma_original: montura.articulo.forma_oma_montura, admite_biselado_forma_oma: montura.articulo.admite_biselado_forma_oma, fecha_modificacion_forma_oma: montura.articulo.fecha_modificacion_forma_oma },
            },
          );
        }
      }
    }
    obtenerFiltrosFromDB();
  }

  onSeleccionarLente(datosLentes) {
    const { iniciarVentanaTrazadora } = this.props;
    const { usaVentanaTrazadora } = datosLentes;
    if (usaVentanaTrazadora) {
      iniciarVentanaTrazadora(datosLentes);
    } else {
      this.setLentes(datosLentes);
    }
  }

  onGuardarSuplementos({ suplementos, tracerData }) {
    const { datosLenteSeleccionada } = this.props;
    const datosLentes = formatearDatosDeTrazadora(datosLenteSeleccionada, tracerData, suplementos);
    this.setLentes(datosLentes);
  }

  setLentes(params) {
    const { setGafaGraduada, match } = this.props;
    if (!match) return;
    const { params: { encargoUUID, linea } } = match;
    setGafaGraduada({ encargoUUID, linea, params });
    this.goToEncargo(encargoUUID);
  }

  setPage(page) {
    this.setState({ page });
  }

  goBack() {
    const { history, match } = this.props;
    const { params: { encargoUUID } } = match;

    history.goBack();
  }

  goToEncargo(encargoUUID) {
    const { history } = this.props;
    history.push('/encargos/crear');
  }

  renderSeleccionarPageModal() {
    const { page, seleccionModalTitle } = this.state;
    const { numLentes } = this.props;
    return (
      <Modal
        title={numLentes ? `${seleccionModalTitle} (${numLentes})` : seleccionModalTitle}
        visible={page === SELECCIONAR_PAGE}
        width={1234}
        footer={null}
        onCancel={() => this.setPage(FILTRAR_PAGE)}
      >
        <PELSeleccionarPage
          pedirSuplementos
          style={{ height: 640 }}
          showPelFooterTopBorder
          onSeleccionarLente={params => this.onSeleccionarLente(params)}
          onClose={() => this.goBack()}
          onGoBack={() => this.setPage(FILTRAR_PAGE)}
        />
      </Modal>
    );
  }

  render() {
    const { page } = this.state;
    const { sagas, match } = this.props;
    const { params: { encargoUUID, linea } } = match;
    const { LENTES_PEL_MIS_CATALOGOS } = sagas;
    const { success: catalogosCargados } = LENTES_PEL_MIS_CATALOGOS || { success: false };
    return (
      <Box height="100%">
        <style>{'.ant-modal-body{ padding: 0 !important;}'}</style>
        <Page
          tituloTraduccionId="encargos.seleccion_de_lentes"
          navigationItems={[
            {
              node: <Text translationId="navegacion.home" />,
              link: '',
            },
            {
              node: <Text translationId="navegacion.encargos" />,
            },
            {
              node: <Text>{`Nº ${encargoUUID}`}</Text>,
              link: '/encargos/crear',
            },
          ]}
        >
          <TwoColumnsFlexLayout
            height="100%"
            paddingBottom="48px"
            preset="golden"
            leftContent={(
              <Box height="100%">
                <PELFiltrarPage
                  catalogosCargados={catalogosCargados}
                  onClose={() => this.goBack()}
                  onClick={() => this.setState({ page: SELECCIONAR_PAGE })}
                />
                <ShowIf condition={page === SELECCIONAR_PAGE}>
                  {this.renderSeleccionarPageModal()}
                </ShowIf>
                <VentanaTrazadora onGuardarSuplementos={(params) => {
                  this.onGuardarSuplementos(params);
                }}
                />
              </Box>
          )}
            leftColumnStyle={{ height: '100%' }}
            rightColumnStyle={{ paddingLeft: '16px' }}
            rightContent={(
              <Box>
                <ResumenEncargo
                  mostrarGuardado
                />
              </Box>
          )}
          />
        </Page>
      </Box>
    );
  }
}


const mapStateToProps = ({
  sagas, auth, encargosCreador, pel,
}) => ({
  permisos: auth.permisos,
  promocion: encargosCreador.promocion,
  encargos: encargosCreador.encargos,
  numLentes: pel.filtrador.lentes ? Object.keys(pel.filtrador.lentes).length : 0,
  datosLenteSeleccionada: pel.filtrador.datosLenteSeleccionada,
  sagas,
});
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setModo,
    setVieneDe,
    seleccionarCaracteristicaFiltrado,
    obtenerFiltrosFromDB,
    setGafaGraduada,
    iniciarVentanaTrazadora,
  }, dispatch);
}

EncargosCrearPELPage.propTypes = {
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  encargos: PropTypes.arrayOf(
    PropTypes.shape({ uuid: PropTypes.string, pack: PropTypes.shape({}) }),
  ).isRequired,
  promocion: promocionType.isRequired,
  permisos: permisosType.isRequired,
  setGafaGraduada: PropTypes.func.isRequired,
  setModo: PropTypes.func.isRequired,
  setVieneDe: PropTypes.func.isRequired,
  seleccionarCaracteristicaFiltrado: PropTypes.func.isRequired,
  numLentes: PropTypes.number,
};
EncargosCrearPELPage.defaultProps = {
  numLentes: 0,
};
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(EncargosCrearPELPage));
